import { MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NovaPublicacao() {
    const navigate = useNavigate();

    return (
        <div className="w-full overflow-hidden rounded-2xl border border-emerald-100/80 bg-gradient-to-r from-emerald-50/80 via-white to-emerald-50/50 shadow-sm ring-1 ring-emerald-100/40 transition-all duration-300 hover:shadow-md">
            <div className="flex items-center gap-4 px-6 py-5">
                <div className="flex-shrink-0">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/80 shadow-sm ring-1 ring-emerald-100">
                        <MessageCircle className="h-6 w-6 text-emerald-700" />
                    </div>
                </div>
                <input
                    className="flex-1 rounded-2xl border border-emerald-100 bg-white/90 px-5 py-4 text-base text-gray-900 placeholder:text-gray-400 shadow-sm transition focus:border-uem-primary focus:outline-none focus:ring-2 focus:ring-uem-primary/30"
                    placeholder="Em que estás a pensar?"
                    onClick={() => navigate('/publicar')}
                    readOnly
                />
            </div>
        </div>
    );
}